/* One nonmodal cart-add flow on phone and tablet; desktop keeps its existing handlers. */
(() => {
  'use strict';
  if (window.asmTouchAddFeedback) return;
  const touch = matchMedia('(max-width:989px), (max-width:1366px) and (pointer:coarse)');
  const states = new WeakMap();
  const errors = new WeakMap();
  const busyForms = new WeakSet();
  let badgeVersion = 0;
  const enabled = () => touch.matches;
  const localeRoot = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');

  function reset(button) {
    const token = states.get(button);
    if (!token) return;
    clearTimeout(token.timer);
    token.label.remove();
    button.removeAttribute('data-asm-add-feedback');
    if (token.live === null) button.removeAttribute('aria-live');
    else button.setAttribute('aria-live', token.live);
    if (token.ariaLabel === null) button.removeAttribute('aria-label');
    else button.setAttribute('aria-label', token.ariaLabel);
    states.delete(button);
  }
  function unlock(token) {
    if (!token || !token.manageDisabled) return;
    const button = token.button;
    const scope = token.form && (token.form.closest('.asm-product') || token.form);
    const selected = scope && scope.querySelector('[data-asm-variant],select[name="id"]');
    const option = selected && selected.selectedOptions[0];
    const soldOut = option && (option.disabled || option.dataset.available === 'false');
    // Native variant controls own availability. Pending uses aria-disabled, so restoring
    // feedback cannot re-enable a different, now unavailable variant.
    if (soldOut) button.disabled = true;
    if (token.ariaDisabled === null) button.removeAttribute('aria-disabled');
    else button.setAttribute('aria-disabled', token.ariaDisabled);
    if (token.ariaBusy === null) button.removeAttribute('aria-busy');
    else button.setAttribute('aria-busy', token.ariaBusy);
  }
  function begin(button, options = {}) {
    if (!enabled() || !button) return null;
    reset(button);
    const label = document.createElement('span');
    label.className = 'asm-add-feedback-label';
    label.setAttribute('data-asm-add-feedback-label', '');
    label.textContent = 'Əlavə edilir…';
    const token = {
      button, label, form: button.form, timer: 0,
      manageDisabled: options.manageDisabled !== false,
      variantId: options.variantId, ariaDisabled: button.getAttribute('aria-disabled'),
      ariaBusy: button.getAttribute('aria-busy'), live: button.getAttribute('aria-live'),
      ariaLabel: button.getAttribute('aria-label'),
    };
    states.set(button, token);
    button.appendChild(label);
    button.dataset.asmAddFeedback = 'loading';
    button.setAttribute('aria-live', 'polite');
    button.setAttribute('aria-label', label.textContent);
    if (token.manageDisabled) {
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
    }
    return token;
  }
  function finish(token, state, text, duration) {
    if (!token || states.get(token.button) !== token) return;
    unlock(token);
    const scope = token.form && (token.form.closest('.asm-product') || token.form);
    const current = scope && scope.querySelector('[data-asm-variant],[name="id"]');
    if (token.variantId && current && current.value !== token.variantId) {
      reset(token.button);
      return;
    }
    token.button.dataset.asmAddFeedback = state;
    token.label.textContent = text;
    token.button.setAttribute('aria-label', text);
    token.timer = setTimeout(() => {
      if (states.get(token.button) === token) reset(token.button);
    }, duration);
  }
  function success(token) { finish(token, 'success', 'Əlavə olundu', 1400); }
  function error(token, uncertain = false) { finish(token, 'error', uncertain ? 'Nəticəni yoxlayın' : 'Əlavə edilmədi', 2200); }
  window.asmTouchAddFeedback = { enabled, begin, success, error, reset };

  function errorMessage(data, uncertain) {
    if (uncertain) return 'Əlavənin nəticəsi dəqiqləşmədi. Təkrar göndərmədən əvvəl səbəti yoxlayın.';
    const detail = data && (data.description || data.message);
    if (/sold out|out of stock|not available|unavailable|inventory|quantity|stock|mövcud|miqdar|stok/i.test(String(detail || ''))) {
      return 'Seçilən miqdar mövcud deyil. Miqdarı və satış vahidini yoxlayın.';
    }
    return 'Məhsul səbətə əlavə edilmədi. Yenidən cəhd edin.';
  }
  function message(form, text) {
    let box = errors.get(form);
    if (!box && !text) return;
    if (!box) {
      box = document.createElement('p');
      box.className = 'asm-add-feedback-error';
      box.setAttribute('data-asm-add-error', '');
      box.setAttribute('role', 'alert');
      // Catalog cards keep a fixed image/control area. Put details immediately
      // below that card, in the same grid item, so an error cannot be cropped.
      const card = form.closest('.card-wrapper');
      if (card) card.insertAdjacentElement('afterend', box);
      else form.appendChild(box);
      errors.set(form, box);
    }
    box.textContent = text || '';
    box.hidden = !text;
  }
  function hidePreviousPopup() {
    const native = document.querySelector('cart-notification');
    if (native && native.notification && native.notification.classList.contains('active') && native.close) native.close();
    document.querySelectorAll('.asm-cart-popup.is-visible,.asm-order-popup.is-open,#asm-order-popup.is-open').forEach(popup => {
      popup.classList.remove('is-visible', 'is-open');
      popup.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.classList.remove('asm-popup-open');
  }
  function publishAdded(result, variantId) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'asm-touch-add-feedback', productVariantId: variantId, cartData: result,
        })).catch(() => {});
      } catch (_) {}
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: result }));
  }
  function refreshBadge(result) {
    const version = ++badgeVersion;
    const bubble = document.getElementById('cart-icon-bubble');
    const section = result.sections && result.sections['cart-icon-bubble'];
    if (bubble && typeof section === 'string') {
      const parsed = new DOMParser().parseFromString(section, 'text/html');
      const updated = parsed.getElementById('cart-icon-bubble') || parsed.querySelector('.shopify-section');
      if (updated) {
        bubble.innerHTML = updated.innerHTML;
        const countNode = updated.querySelector('.cart-count-bubble [aria-hidden="true"]');
        const count = countNode && countNode.textContent.trim();
        if (/^\d+$/.test(count || '') && window.asmUpdateCartCount) window.asmUpdateCartCount(Number(count));
      }
    }
    fetch(localeRoot() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(response => { if (!response.ok) throw new Error('badge'); return response.json(); })
      .then(cart => {
        if (version !== badgeVersion || !Number.isFinite(cart.item_count)) return;
        if (window.asmUpdateCartCount) window.asmUpdateCartCount(cart.item_count);
      }).catch(() => {});
  }

  async function submit(event) {
    if (!enabled()) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.closest('[data-asm-fast-order],.asm-quick-order')) return;
    let action;
    try { action = new URL(form.action, location.href); } catch (_) { return; }
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    // Window capture precedes every existing document/native controller. Busy repeats stop here too.
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter && event.submitter.matches('button,input[type="submit"]')
      ? event.submitter : form.querySelector('button[type="submit"],button[name="add"]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' || busyForms.has(form)) return;
    const data = new FormData(form);
    const home = form.closest('.asm-product');
    const selected = home ? home.querySelector('[data-asm-variant]') : form.querySelector('select[name="id"]');
    const option = selected && selected.selectedOptions[0];
    if (option && (option.disabled || option.dataset.available === 'false')) return;
    if (home && selected) data.set('id', selected.value);
    const quantityInput = home ? home.querySelector('[data-asm-qty]') : Array.from(form.elements).find(input => input.name === 'quantity');
    if (home && quantityInput) data.set('quantity', quantityInput.value);
    const variantId = String(data.get('id') || '');
    const quantity = Number(data.get('quantity') || 1);
    if (!/^\d+$/.test(variantId) || !Number.isSafeInteger(quantity) || quantity < 1 || (quantityInput && !quantityInput.validity.valid)) {
      message(form, 'Satış vahidini və düzgün miqdarı seçin.');
      return;
    }
    message(form, '');
    const productForm = form.closest('product-form');
    if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage();
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && cart.getSectionsToRender) {
      data.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
      data.set('sections_url', location.pathname);
    }
    busyForms.add(form);
    hidePreviousPopup();
    const token = begin(button, { variantId });
    let result, response, confirmed = false;
    try {
      response = await fetch((window.routes && window.routes.cart_add_url) || localeRoot() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: data,
      });
      result = await response.json();
      const hasIdentity = item => item && ((Number.isSafeInteger(Number(item.id)) && Number(item.id) > 0) || (typeof item.key === 'string' && /^\d+:.+/.test(item.key)));
      const validResult = hasIdentity(result) || (result && Array.isArray(result.items) && result.items.length > 0 && result.items.every(hasIdentity));
      if (!response.ok || !result || result.status || !validResult) {
        message(form, errorMessage(result, response.ok));
        error(token, response.ok);
        refreshBadge({});
        return;
      }
      confirmed = true;
      success(token);
      // Badge and subscribers are secondary; their failures cannot turn a confirmed add into an error.
      publishAdded(result, variantId);
      refreshBadge(result);
    } catch (_) {
      if (!confirmed) {
        message(form, errorMessage(null, !response || response.ok));
        error(token, !response || response.ok);
      }
    } finally {
      busyForms.delete(form);
      unlock(token);
    }
  }
  window.addEventListener('submit', submit, true);
})();
